import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccountRoutingModule } from './account-routing.module';
import { AccountDetailsComponent } from './components/account-details/account-details.component';
import { UpdatePaymentMethodComponent } from './components/update-payment-method/update-payment-method.component';
import { UpdateAddressComponent } from './components/update-address/update-address.component';
import { CustomerService } from './services/customer.service';
import { CustomerStorageService } from './services/customer-storage.service';
import { AddressService } from './services/address.service';
import { ConstsHelper } from '../../helpers/consts.helper';
import { customerReducer } from './store/reducers/customer.reducer';
import { CustomerEffects } from './store/effects/customer.effects';
import { AddressEffects } from './store/effects/address.effects';
import { PaymentMethodEffects } from './store/effects/payment-method.effects';
import { UpdateAccountComponent } from './components/update-account/update-account.component';
import { AddressListComponent } from './components/address-list/address-list.component';
import { addressReducer } from './store/reducers/address.reducer';
import { confirmationAddressReducer } from './store/reducers/confirmation-address.reducer';
import { PaymentMethodsListComponent } from './components/payment-methods-list/payment-methods-list.component';
import { UpdatePasswordComponent } from './components/update-password/update-password.component';
import { AccountManagementComponent } from './components/account-management/account-management.component';
import { SharedModule } from '../shared/shared.module';
import { UpdateIbanComponent } from './components/update-iban/update-iban.component';
import { NewPaymentCardComponent } from './components/new-payment-card/new-payment-card.component';
import { cardsReducer } from './store/reducers/cards.reducer';
import { CardsEffects } from './store/effects/cards.effects';
import { DeleteShippingAddressComponent } from './components/delete-shipping-address/delete-shipping-address.component';
import { CreateShippingAddressComponent } from './components/create-shipping-address/create-shipping-address.component';


@NgModule({
  declarations: [
      AccountDetailsComponent,
      UpdateAddressComponent,
      UpdateAccountComponent,
      UpdatePaymentMethodComponent,
      UpdateAddressComponent,
      AddressListComponent,
      PaymentMethodsListComponent,
      UpdatePasswordComponent,
      AccountManagementComponent,
      UpdateIbanComponent,
      NewPaymentCardComponent,
      DeleteShippingAddressComponent,
      CreateShippingAddressComponent
  ],
  imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      AccountRoutingModule,
      StoreModule.forFeature(ConstsHelper.REDUCER_CUSTOMER, customerReducer),
      StoreModule.forFeature(ConstsHelper.REDUCER_ADDRESS, addressReducer),
      StoreModule.forFeature(ConstsHelper.REDUCER_CONFIRMATION_ADDRESS, confirmationAddressReducer),
      StoreModule.forFeature(ConstsHelper.REDUCER_CARDS, cardsReducer),
      EffectsModule.forFeature(
          [
              CustomerEffects,
              AddressEffects,
              PaymentMethodEffects,
              CardsEffects
          ]
      ),
      SharedModule
  ],
  providers: [
      CustomerService,
      CustomerStorageService,
      AddressService
  ]
})
export class AccountModule { }
